exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table .success-row {\r\n  background: #ecf5ff;\n}\r\n", ""]);

// exports
